export default __webpack_public_path__ + "static/texture-yellow-dots-07-9ed5a5af4e1f3b0b2a62f808fa44e9a9.png";